import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import AboutPage from "../views/AboutPage.vue";
import ServicePage from "../views/ServicePage.vue";
import CareerPage from "@/views/CareerPage.vue";
import JobRequirement from "@/views/JobRequirement.vue";
import JobRegistration from "@/views/JobRegistration.vue";
import ContactPage from "@/views/ContactPage.vue";
import EarnPage from "@/views/EarnPage.vue";
import FaqPage from "@/views/FaqPage.vue";
import PropertiesPage from "@/views/PropertiesPage.vue";
import AchievementsPage from "@/views/AchievementsPage.vue";
import UltraPage from "@/views/UltraPage.vue";
import SitesServicesPage from "@/views/SitesServicesPage.vue";
import ThirdPartySale from "@/views/ThirdPartySale.vue";
import YolaBranch from "@/views/YolaBranch.vue";
import LagosBranch from "@/views/LagosBranch.vue";
import KanoBranch from "@/views/KanoBranch.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomePage,
    },
    {
      path: "/about",
      name: "about",
      component: AboutPage,
    },
    {
      path: "/services",
      name: "service",
      component: ServicePage,
    },
    {
      path: "/career",
      name: "career",
      component: CareerPage,
    },
    {
      path: "/career/job-requirement",
      name: "requirement",
      component: JobRequirement,
    },
    {
      path: "/career/job-requirement/application-form",
      name: "application",
      component: JobRegistration,
    },
    {
      path: "/contact-us",
      name: "contact",
      component: ContactPage,
    },
    {
      path: "/earn-with-us",
      name: "referral",
      component: EarnPage,
    },
    {
      path: "/faq",
      name: "faq",
      component: FaqPage,
    },
    {
      path: "/properties",
      name: "properties",
      component: PropertiesPage,
    },
    {
      path: "/achievements",
      name: "achievements",
      component: AchievementsPage,
    },
    {
      path: "/ultra",
      name: "ultra",
      component: UltraPage,
    },
    {
      path: "/sites-and-services",
      name: "sites-and-services",
      component: SitesServicesPage,
    },
    {
      path: "/third-party-sale",
      name: "third-party-sale",
      component: ThirdPartySale,
    },
    {
      path: "/yola-branch",
      name: "yola-branch",
      component: YolaBranch,
    },
    {
      path: "/lagos-branch",
      name: "lagos-branch",
      component: LagosBranch,
    },
    {
      path: "/kano-branch",
      name: "kano-branch",
      component: KanoBranch,
    },
  ],
});

export default router;
